import i from"./to-primitive.js";import o from"./is-symbol.js";var e=i,m=o,a=function(t){var r=e(t,"string");return m(r)?r:r+""};export{a as default};
